import Auth from './auth/reducer';
import App from './app/reducer';
import LanguageProvider from './languageSwitcher/reducer';

export default {
  Auth,
  App,
  LanguageProvider,
};
